export const safeStringify = (obj: unknown): string => {
  try {
    return JSON.stringify(obj, null, 2);
  } catch (err) {
    return '[Could not stringify object]';
  }
};
